import Backbone from 'backbone';
import Bowser2 from 'bowser';

var Session_Recording = Backbone.Model.extend({
    defaults: {
        session_id             : '',
        share_key              : '',
        account_id             : 0,
        project_id             : 0,
        feedback_id            : 0,
        survey_response_id     : 0,
        events                 : '',
        s3_file                : '',
        timestamp              : 0,
        domain                 : '',
        duration               : 0,
        user_agent             : '',
        ua_data                : '',
        user_identification    : '',
        location               : '',
        tag                    : '',
        delete_date            : 0
    },

    getShareUrl: function() {
        return window.location.origin + '/sr/' + this.get('share_key') + '/';
    },

    getDuration: function() {
        var seconds = Math.floor(this.get('duration'));

        var hour = Math.floor(seconds / 3600);
        var min  = Math.floor((seconds - hour * 3600) / 60);
        var sec  = seconds - hour * 3600 - min * 60;

        if (min < 10) {
            min = '0' + min;
        }

        if (sec < 10) {
            sec = '0' + sec;
        }

        return (hour ? hour + ':' : '') + min + ':' + sec;
    },

    getBowserDetection: function() {
        if (!this._bowser_detection) {
            var user_agent = this.get('user_agent') || 'unknown';
            this._bowser_detection = Bowser2.getParser(user_agent);
        }

        return this._bowser_detection;
    },

    isApple: function() {
        var browser = this.getBowserDetection();
        return browser.getPlatform().vendor === 'Apple';
    },

    isAndroid: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Android';
    },

    isWindowsPhone: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Windows Phone';
    },

    isWindows: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Windows';
    },

    isLinux: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Linux';
    },

    getDevice: function() {
        var browser = this.getBowserDetection();
        var platform_type = browser.getPlatformType();

        switch (platform_type) {
            case 'mobile':
                return '<i class="fa-regular fa-mobile tooltip" data-title="Mobile"></i>';
            case 'tablet':
                return '<i class="fa-regular fa-tablet tooltip" data-title="Tablet"></i>';
            default:
                return '<i class="fa-regular fa-display tooltip" data-title="Desktop"></i>';
        }
    },

    getOSName: function() {
        var browser = this.getBowserDetection();
        var os = browser.getOS();

        var os_name = browser.getOSName();
        var os_version = (os.versionName || browser.getOSVersion() || '');

        try {
            var ua_data = JSON.parse(this.get('ua_data'));

            var ua_platform_name    = ua_data.platform ? ua_data.platform.toLowerCase() : null;
            var ua_platform_version = ua_data.platformVersion || null;

            if (ua_platform_version) {
                if (ua_platform_name === 'windows') {
                    if (parseInt(ua_platform_version.split('.')[0], 10) > 13) {
                        // Windows 11
                        os_version = 11;
                    }
                } else if (ua_platform_name === 'macos') {
                    switch (parseInt(ua_platform_version.split('.')[0], 10)) {
                        case 11:
                            os_version = 'Big Sur ' + ua_platform_version;
                            break;
                        case 12:
                            os_version = 'Monterey ' + ua_platform_version;
                            break;
                        case 13:
                            os_version = 'Ventura ' + ua_platform_version;
                            break;
                        case 14:
                            os_version = 'Sonoma ' + ua_platform_version;
                            break;
                    }
                }
            }
        } catch(e) {
        }

        return (os_name ? os_name + ' ' : '') + os_version;
    },

    getOSIcon: function(show_tooltip) {
        var os_name = this.getOSName();
        var os_icon = '';

        if (this.isAndroid()) {
            os_icon = '<i class="fa-brands fa-android text-android tooltip"' + (show_tooltip ? ' data-title="' + os_name + '"' : '') + '></i>';
        } else if (this.isApple()) {
            os_icon = '<i class="fa-brands fa-apple tooltip"' + (show_tooltip ? ' data-title="' + os_name + '"' : '') + '></i>';
        } else if (this.isWindowsPhone() || this.isWindows()) {
            os_icon = '<i class="fa-brands fa-windows text-windows tooltip"' + (show_tooltip ? ' data-title="' + os_name + '"' : '') + '></i>';
        } else if (this.isLinux()) {
            os_icon = '<i class="fa-brands fa-linux tooltip"' + (show_tooltip ? ' data-title="' + os_name + '"' : '') + '></i>';
        }

        return os_icon;
    },

    getBrowser: function() {
        if (!this.get('user_agent')) {
            return '';
        }

        var browser = this.getBowserDetection();
        var browser_icon = this.getBrowserIcon();
        var browser_name = browser.getBrowserName();
        var browser_version = browser.getBrowserVersion();

        if (browser_version) {
            browser_version = browser_version.split('.');

            if (browser_version.length >= 3) {
                browser_version = browser_version[0] + '.' + browser_version[1];
            } else {
                browser_version = browser_version.join('.');
            }
        }

        if (browser_name) {
            return '<div class="flex-start">' +
                      browser_icon +
                      '<span class="margin-left-4">' + browser_name + ' ' + browser_version + '</span>' +
                   '</div>';
        } else {
            return '';
        }
    },

    getBrowserIcon: function(show_tooltip) {
        var browser = this.getBowserDetection();
        var browser_name = browser.getBrowserName();
        var brwower_version = browser.getBrowserVersion();
        var browser_detail = browser_name + ' ' + brwower_version;

        var icon_src = '';

        switch (browser_name) {
            case 'Chrome':
                icon_src = '/image/chrome_logo.png';
                break;
            case 'Firefox':
                icon_src = '/image/firefox_logo.png';
                break;
            case 'Internet Explorer':
                icon_src = '/image/ie_logo.png';
                break;
            case 'Microsoft Edge':
                icon_src = '/image/edge_logo.png';
                break;
            case 'Safari':
                icon_src = '/image/safari_logo.png';
                break;
        }

        if (icon_src) {
            return '<img width="14" height="14" src="' + icon_src + '"' + (show_tooltip ? ' class="tooltip" data-title="' + browser_detail + '"' : '') + '>';
        } else {
            return '';
        }
    }
});

export default Session_Recording;